export default function ThoughtSection(props) {
  // Safe split for subheading (e.g. "१. नियम (Rules)")
  const splitSubheading = props.subheading ? props.subheading.split('.') : [];
  const hasDot = splitSubheading.length > 1;

  return (
    <section className="my-16 px-2 md:px-8 group">
      <div
        className={
          "flex flex-col gap-10 md:gap-16 items-center " +
          (props.position === "start" ? "md:flex-row" : "md:flex-row-reverse")
        }
      >
        {/* Text Content */}
        <div className="w-full md:w-1/2 flex flex-col justify-center glassmorphism p-8 md:p-12 rounded-3xl shadow-xl border-t-4 border-main transform transition duration-500 hover:-translate-y-2 hover:shadow-2xl relative overflow-hidden">
          
          {/* Decorative background element */}
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-gradient-to-br from-main/20 to-accent/20 rounded-full blur-3xl"></div>

          {props.subheading ? (
            <div className="mb-6 flex items-center z-10">
              {hasDot ? (
                <>
                  <span className="text-5xl font-bold text-main/80 mr-4 drop-shadow-sm">{splitSubheading[0]}</span>
                  <h3 className="text-2xl md:text-3xl font-bold text-heads font-Philosopher tracking-wide">
                    {splitSubheading.slice(1).join('.')}
                  </h3>
                </>
              ) : (
                <h3 className="text-2xl md:text-3xl font-bold text-heads font-Philosopher tracking-wide">
                  {props.subheading}
                </h3>
              )}
            </div>
          ) : null}
          
          <div className="w-20 h-1 bg-gradient-to-r from-main to-accent rounded-full mb-8 z-10"></div>

          {props.paraHtml ? (
            <div
              className="text-lg md:text-xl leading-relaxed text-heads/85 space-y-4 z-10"
              dangerouslySetInnerHTML={{ __html: props.paraHtml }}
            ></div>
          ) : null}
        </div>

        {/* Overlapping Images Gallery */}
        <div className="w-full md:w-1/2 relative h-[350px] md:h-[450px]">
           {props.img && props.img2 ? (
             <>
               <img
                 src={props.img}
                 className="absolute top-0 left-0 md:left-6 w-[65%] h-[75%] object-cover rounded-3xl shadow-xl border-4 border-white z-10 transition duration-700 ease-in-out group-hover:scale-105 group-hover:-rotate-2"
                 alt=""
               />
               <img
                 src={props.img2}
                 className="absolute bottom-0 right-0 md:right-6 w-[60%] h-[70%] object-cover rounded-3xl shadow-2xl border-4 border-white z-20 transition duration-700 ease-in-out group-hover:scale-110 group-hover:translate-y-[-10px] group-hover:rotate-2"
                 alt=""
               />
             </>
           ) : props.img ? (
              <img
                src={props.img}
                className="w-full h-full object-cover rounded-3xl shadow-2xl border-4 border-white transition duration-700 group-hover:scale-105"
                alt=""
              />
           ) : (
             <div className="w-full h-full bg-gray-200 animate-pulse rounded-3xl"></div>
           )}
        </div>
      </div>
    </section>
  );
}